/**
 * Shared table styling for the "Ingredient Details" tabs, matched to the
 * Ingredient List table (src/screens/lcaIngredients/ingredientList/components/IngredientTable.tsx)
 * so every table across the details modal (History, Supplier Ingredients,
 * Volume And Cost, Related Products, ...) reads as one system: white card
 * container with rounded corners, and a primary-tinted header row.
 */
export const INGREDIENT_DETAILS_TABLE_CONTAINER_CLASS =
  "tw-overflow-x-auto tw-rounded-lg tw-border tw-border-border tw-bg-white";

export const INGREDIENT_DETAILS_TABLE_HEADER_ROW_CLASS =
  "tw-border-b-0 tw-bg-primary/5 hover:tw-bg-primary/5 [&_th]:tw-bg-primary/5 [&_th]:tw-text-primary [&_th]:tw-font-semibold [&_th]:tw-align-middle";

export const INGREDIENT_DETAILS_TABLE_ROW_CLASS = "tw-bg-white hover:tw-bg-muted/50";
